<template>
<v-layout justify-center>
    <v-responsive max-width="1440px" width="100%" height="100%" class="overflow-visible">
        <v-row class="mt-8" justify="center" align="center">
            <v-col cols="auto" class="pt-0 pb-0 headline text-start">CP 관리</v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="pt-0 pb-0">
                <v-btn class="ma-2" color="secondary" rounded @click="showSearch = !showSearch">
                    <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터
                </v-btn>
            </v-col>
        </v-row>

        <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mx-auto">
                <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="12" md="3" class="py-0">
                            <v-select v-model="filter.onDisplay" label="노출여부" placeholder=" " hide-details :items="onDisplays" item-text="text" item-value="value"/>
                        </v-col>
                        <v-col cols="12" md="3" class="py-0">
                            <v-select v-model="filter.searchKey" label="검색조건" placeholder=" " hide-details :items="searchKeys" item-text="name" item-value="value"/>
                        </v-col>
                        <v-col cols="12" md="3" class="py-0">
                            <v-text-field v-model="filter.searchValue" label="검색어" placeholder=" " hide-details :disabled="!filter.searchKey"/>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded text @click="search">
                        <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>

        <v-row class="mt-4" align="end">
            <!-- <v-col>
                <span class="caption primary--text">* 마우스로 드래그 하여 CP 순서를 변경 할 수 있습니다.</span>
            </v-col> -->
            <v-spacer></v-spacer>
            <v-col cols="auto">
                <v-btn color="white" class="green--text px-2" @click="excel">
                    <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>엑셀다운로드
                </v-btn>
            </v-col>
        </v-row>

        <v-data-table :headers="cpsHeaders" :items="cps" :loading="loading" disable-sort disable-pagination hide-default-footer class="elevation-1">
            <template v-slot:item.phone="{ item }">
                <div>{{String(item.phone).phoneNumberFormat()}}</div> 
            </template>
            <template v-slot:item.email="{ item }">
                <div>{{ item.email ?  item.email : '-'}}</div> 
            </template>
            <template v-slot:item.onDisplay="{ item }">
                <v-switch v-model="item.onDisplay" hide-details class="pa-0 ma-0 d-inline-block" color="red lighten-2" @change="update(item)"/>
            </template>
            <template v-slot:item.cash="{ item }">
                <div>{{ item.cash.format() }}<v-icon size="20" right @click="charge(item)">mdi-plus-circle-multiple-outline</v-icon></div> 
            </template>
            <template v-slot:item.createdAt="{ item }">
                <div>{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</div> 
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon size="18" @click="edit(item)" class="mx-1"> mdi-pencil </v-icon>
                <v-icon size="18" @click="remove(item)" class="mx-1"> mdi-delete </v-icon>
            </template>
        </v-data-table>

        <v-row class="my-3"></v-row>

        <cp-details-dialog ref="cp-details-dialog" @save="search"></cp-details-dialog>
        <cp-cash-dialog ref="cp-cash-dialog" @save="search"></cp-cash-dialog>

    </v-responsive>
</v-layout>
</template>

<script>
import XLSX from "xlsx";
import api from "@/api";
import draggable from "vuedraggable";

import {
    mdiMicrosoftExcel
} from "@mdi/js";
import cpDetailsDialog from '@/components/console/partner/cp-details-dialog.vue';
import cpCashDialog from '@/components/console/partner/cp-cash-dialog.vue';

export default {
    components: {
        cpDetailsDialog,
        cpCashDialog,
        draggable,
    },
    data() {
        return {
            mdiMicrosoftExcel, // 엑셀아이콘

            showSearch: true,

            loading: true,

            filter: {
                searchKey: "name",
                searchValue: null,
                onDisplay: false,
            },

            searchKeys: [
                { name: ":: 전체 ::", value: null },
                { name: "이름", value: "name" },
                { name: "연락처", value: "phone" },
                { name: "이메일", value: "email" }
            ],

            onDisplays: [
                { text: ":: 전체 ::", value: null },
                { text: "노출", value: false },
                { text: "미노출", value: true }
            ],

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            cps: [],
            cpsHeaders: [
                { text: "이름", align: "center", width: 140, value: "name", },
                { text: "연락처", align: "center", width: 110, value: "phone", },
                { text: "이메일", align: "center", width: 128, value: "email", },
                { text: "노출 / 미노출", width: 80, align: "center", value: "onDisplay", },
                { text: "캐시잔액", width: 160, align: "end", value: "cash", },
                { text: "등록일자", align: "center", width: 160, value: "createdAt", },
                { text: "Actions", value: "actions", width: 100, align: "center", },
            ],

            editItem: null,
            defaultItem: {
                username: null,
                password: null,

                name: null,
                phone: null,
                email: null,

                cash: 0,

                riskManagement: {
                    maxPrice: 0,
                    alarms: [{
                        price: 0,
                        phone: null,
                        message: null
                    }]
                }
            }
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            await this.search();
        },
        async search() {
            this.cps = [];
            this.loading = true;

            let { me } = await api.console.me.get();
            this.me = me;

            var { summary, cps } = await api.console.cps.gets({
                params: this.filter
            });
            
            // var { summary, cps } = await api.console.me.cps.gets({
            //     params: this.filter
            // });

            this.cps = cps;
            // this.pageCount = Math.ceil(cps.length / this.limit);

            this.loading = false;
        },

        edit(cp) {
            this.$refs["cp-details-dialog"].editItem = JSON.parse(JSON.stringify(cp));
            this.$refs["cp-details-dialog"].open();
        },

        charge(cp){
            this.$refs["cp-cash-dialog"].cp = cp;
            this.$refs["cp-cash-dialog"].open();
        },

        async remove(cp){
            try{
                if(confirm("삭제하시겠습니까?")){
                    await api.console.cps.delete(cp);
    
                    await this.search();
                    alert("삭제되었습니다");
                }
            }
            catch(error){
                console.error(error);
            }
        },

        async update(data){
            await api.console.cps.put(data);
        },

        async excel() {
            try {
                var { summary, cps } = await api.console.cps.gets({
                    params: this.filter
                });

                var rows = [];
                cps.forEach(cp => {
                    rows.push({
                        "아이디": cp.username,
                        "이름": cp.name,
                        "연락처": cp.phone,
                        "이메일": cp.email,
                        "캐시잔액": cp.cash,
                        "등록일자": cp.createdAt.toDateTime(),
                    });
                });

                var workbook = new XLSX.utils.book_new();
                var worksheet = XLSX.utils.json_to_sheet(rows);

                XLSX.utils.book_append_sheet(workbook, worksheet, "new");
                XLSX.writeFile(workbook, "CP 목록.xlsx");
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
    computed: {
        test(){
            return this.$store.state.test;
        }
    }
};
</script>

<style scoped>
.draggable-row {
    cursor: pointer;
}
</style>